import { Alert, Button, Col, Divider, Form, FormInstance, Input, message, Row, Select, Spin, Table, Upload, UploadFile } from 'antd'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FormDatePicker } from '../../Components/FormDatePicker';
import { DeleteOutlined, EditOutlined, EyeOutlined, HistoryOutlined, UploadOutlined } from "@ant-design/icons";
import {
    getAssignedTo,
    getRequestDetailsById,
    getTaskOwnerStatus,
    getTaskInvestigatorStatus,
    getCorrActionOwnerStatus,
    getCorrActionCentralQAStatus,
    getTaskSummaryDetails,
    InsertTasksAsync,
    UpdateTaskAsync,
    GetCorrectiveActionSummaryDetails,
    InsertCorrectiveActionAsync,
    UpdateCorrectiveActionAsync,
    QAClosureSubmitAsync,
    getTaskHistory,
    getCorrectiveActionHistory,
} from '../../Helpers/APIEndpoints/Endpoints';
import { API } from '../../Axios/Axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../AuthStore/AuthStore';
import { RoleEnum } from '../../Enum/RoleEnum';
import { RequestStatusEnum } from '../../Enum/RequestStatusEnum';
import { TaskStatusEnum } from '../../Enum/TaskStatusEnum';
import { useActionHandler } from '../../Components/ActionHandlerContext';
import Modal from "antd/es/modal/Modal";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ApiStatus } from '../../Enum/ApiStatusEnum';
import Loader from '../../Helpers/Loader/Loader';
import { stat } from 'fs';

dayjs.extend(utc);
dayjs.extend(timezone);

const CorrActionDetailsTab = (props: any) => {
    // const [form] = Form.useForm();
    const form = props.form;
    const { interfaceActionHandler } = useActionHandler();

    const [formOptions, setFormOptions] = React.useState<any>({});
    const [taskDetailsData, setTaskDetailsData] = React.useState<any>([]);
    const [correctiveActionDetailsData, setCorrectiveActionDetailsData] = React.useState<any>([]);

    const location = useLocation();
    const { RId } = location.state || {};

    const [alertMessage, setAlertMessage] = useState<string>("");
    const [acceptedTypes] = useState<string>(".doc,.docx,.pdf,.xlsx,.xls,.msg,.eml,.ppt,.pptx,.png,.jpg,.jpeg,.zip");
    const [maxDocCount] = useState<number>(5);
    const [maxFileSize] = useState<number>();
    const [totalMaxFilesSize] = useState<number>(30);
    const [fileList, setFileList] = useState<any[]>([]);

    const { commonContextParams } = useAuthStore();
    const [editingKey, setEditingKey] = useState<number | null>(null);
    const navigate = useNavigate();
    const [taskCurrentStatus, setTaskCurrentStatus] = useState<any>(null);
    const [CorrActionCurrentStatus, setCorrActionCurrentStatus] = useState<any>(null);
    const [isCurrentTaskExtended, setIsCurrentTaskExtended] = useState<any>(false);
    const [isCurrentCorrActionExtended, setIsCurrentCorrActionExtended] = useState<any>(false);
    const [currentInvestigatorStatus, setCurrentInvestigatorStatus] = useState<any>(null);
    const [currentQAStatus, setCurrentQAStatus] = useState<any>(null);
    const [requestStatus, setRequestStatus] = useState<any>();
    const [closureDate, setClosureDate] = useState<any>();
    const [Investigator, setInvestigator] = useState<any>();

    const [ownerFiles, setOwnerFiles] = useState<UploadFile[]>([]);
    const [CAownerFiles, setCAownerFiles] = useState<UploadFile[]>([]);
    const [QAConsodilatedClosureFiles, setQAConsodilatedClosureFiles] = useState<UploadFile[]>([]);
    const [closureFiles, setClosureFiles] = useState<UploadFile[]>([]);
    const [uploadError, setUploadError] = useState<string | null>(null);
    const [deletedOwnerAttachmentIds, setDeletedOwnerAttachmentIds] = useState<string>("");
    const [deletedCorrActionOwnerAttachmentIds, setDeletedCorrActionOwnerAttachmentIds] = useState<string>("");
    const [deletedClosureAttachmentIds, setDeletedClosureAttachmentIds] = useState<string>("");
    const [isEditing, setIsEditing] = useState(false);
    //const [isCorrActionEditing, setCorrActionEditing] = useState(false);
    const [CorrActioneditingKey, setCorrActionEditingKey] = useState<number | null>(null);
    const [isCorrActionBtnEditing, setIsCorrActionBtnEditing] = useState(false);

    const [historyData, setHistoryData] = useState<any>([]);
    const [isHistoryIconClicked, setIsHistoryIconClicked] = useState(false);
    const [corrActionhistoryData, setCorrActionHistoryData] = useState<any>([]);
    const [isCorrActionHistoryIconClicked, setIsCorrActionHistoryIconClicked] = useState(false);
    const [ShowForm, setShowForm] = useState(false);
    const [isReopenRequest, setisReopenRequest] = useState(false);
    const [isAddDisable, setisAddDisable] = useState(false);
    const [isTaskTable, setisTaskTable] = useState(false);
    const [isCorrActionTable, setisCorrActionTable] = useState(false);

    //const [CACreatedForTask, setCorrActionEditingKey] = useState(false);

    const canShowForm =
        isEditing ||
        ((((Number(commonContextParams.roleId) == RoleEnum.Investigator) &&
            requestStatus == RequestStatusEnum.ActionAssignmentPendingWithInvestigator) ||
            ((Number(commonContextParams.roleId) == RoleEnum.CentralQaTeam) &&
                requestStatus == RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa)));

    //const formRef = useRef<FormInstance>(null);
    const formRef = useRef<any>(null);

    const [loading, setLoading] = useState(false);

    const goToNextTab = () => {
        interfaceActionHandler?.NextTab?.();
    };

    const goToPrevTab = () => {
        interfaceActionHandler?.PrevTab?.();
    };

    // Assignee search states for lazy loading dropdown
    const [assigneeOptions, setAssigneeOptions] = useState<any[]>([]);
    const [assigneeLoading, setAssigneeLoading] = useState(false);

    const [correctiveAssigneeOptions, setCorrectiveAssigneeOptions] = useState<any[]>([]);
    const [correctiveassigneeLoading, setCorrectiveAssigneeLoading] = useState(false);

    const assigneeSearchTimeout = useRef<any>(null);
    const correctiveAssigneeSearchTimeout = useRef<any>(null);

    // 🔥 FIX: Separate caches clearly
    const assigneeCache = useRef<Map<string, any[]>>(new Map()); // search term → options
    const assigneeIdCache = useRef<Map<number, any>>(new Map());       // id → {label,value}

    const correctiveassigneeCache = useRef<Map<string, any[]>>(new Map()); // search term → options
    const correctiveAssigneeIdCache = useRef<Map<number, any>>(new Map());

    // Existing caches (OK)
    const assigneeFromTaskSummary = useRef<Map<number, any>>(new Map());
    const assigneeFromCorrectiveActionSummary = useRef<Map<number, any>>(new Map());

    //#region Role Base helper flags    
    const isValidInvestigator =
        Number(commonContextParams?.userId) === Number(Investigator) &&
        Number(commonContextParams?.roleId) === RoleEnum.Investigator;

    const isValidCentralQATeam =
        Number(commonContextParams?.roleId) === RoleEnum.CentralQaTeam;

    const isValidTaskOwner =
        Number(commonContextParams?.roleId) === RoleEnum.TaskActionOwner;

    const isValidCorrectiveActionOwner =
        Number(commonContextParams?.roleId) === RoleEnum.CorrectiveActionOwner;

    // Investigator submit condition
    // const canInvestigatorSubmit =
    //   Number(commonContextParams?.roleId) === RoleEnum.Investigator &&
    //   requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator &&
    //   taskDetailsData?.length > 0;

    const isInvestigator =
        Number(commonContextParams?.roleId) === RoleEnum.Investigator;

    const hasOldTask = taskDetailsData?.some((t: any) => t.taskDetailId);
    const hasNewTask = taskDetailsData?.some((t: any) => !t.taskDetailId);

    const isReopened =
        requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator &&
        hasOldTask;

    const canInvestigatorSubmit =
        isInvestigator &&
        requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator &&
        (
            (!isReopened && taskDetailsData?.length > 0) ||
            (isReopened && hasNewTask)
        );

    // QA submit condition
    const canQASubmit =
        Number(commonContextParams?.roleId) === RoleEnum.CentralQaTeam &&
        requestStatus === RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa &&
        taskDetailsData?.length > 0 &&
        correctiveActionDetailsData?.length === taskDetailsData?.length;

    const canQAClosureSubmit =
        Number(commonContextParams?.roleId) === RoleEnum.CentralQaTeam &&
        requestStatus === RequestStatusEnum.AllCorrectiveActionsClosed;

    const isCorrActionExistsForTask = () => {
        const selectedTask = taskDetailsData.find(
            (x) => x.key === editingKey
        );

        if (!selectedTask) return false;

        return correctiveActionDetailsData.some(
            (x) =>
                x.TaskDetailId === selectedTask.taskDetailId &&
                x.correctiveActionId > 0
        );
    };

    const _isTaskUpdate =
        requestStatus === RequestStatusEnum.TasksWipWithTaskOwner &&
        (isValidTaskOwner || isValidInvestigator);

    const _isCorrActionUpdate =
        requestStatus === RequestStatusEnum.CorrectiveActionsWipWithOwner &&
        (isValidCorrectiveActionOwner || isValidCentralQATeam)

    const _showUpdateButton =
        (_isCorrActionUpdate) &&
        (CorrActioneditingKey);


    const _disableUpdate =
        // (isValidTaskOwner && taskCurrentStatus === TaskStatusEnum.Closed) ||
        // (isValidInvestigator && currentInvestigatorStatus === TaskStatusEnum.Closed) ||
        (isValidCorrectiveActionOwner &&
            (!isCorrActionTable || CorrActionCurrentStatus === TaskStatusEnum.Closed)) ||
        (isValidCentralQATeam &&
            (!isCorrActionTable || currentQAStatus === TaskStatusEnum.Closed));

    const _showCorrActionAdd =
        (requestStatus === RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa ||
            requestStatus === RequestStatusEnum.CorrectiveActionsWipWithOwner) &&
        isValidCentralQATeam //&& !isCorrActionExistsForTask();

    const _showInvestigatorAdd =
        requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator &&
        isValidInvestigator;

    const _showReset =
        // (isValidInvestigator &&
        //     requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator) ||
        (isValidCentralQATeam &&
            (requestStatus === RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa ||
                requestStatus === RequestStatusEnum.CorrectiveActionsWipWithOwner
            ));
    //#endregion

    //#region Reset Fields on Reset Button
    const actionTabFields = [
        "taskTitle",
        "taskDescription",
        "assignedToId",
        "taskDeadline",
        "statusId",
        "remarks",
        "ownerAttachments",
        "InvestigatorStatus",
        "taskClosureRemarks",
        "correctiveactionfinding",
        "taskCorrectiveaction",
        "correctiveActionUserToIds",
        "correctiveActionDeadline",
        "correctiveActionOwnerStatus",
        "correctiveActionOwnerRemarks",
        "CorrectiveActionOwnerAttachments",
        "QAStatus",
        "QAClosureRemarks",
        // "ConsodilatedClosureRemark",
        // "consodilatedCostAssociated",
        // "consodilatedAttachment"
    ];

    const resetActionTab = () => {
        // 1. Reset all tab fields
        form.resetFields(actionTabFields);

        // 2. Clear uploads
        setOwnerFiles([]);
        setCAownerFiles([]);
        setQAConsodilatedClosureFiles([]);
        setClosureFiles([]);

        // 3. Reset TASK states
        setEditingKey(null);
        setTaskCurrentStatus(null);
        setCurrentInvestigatorStatus(null);
        setIsCurrentTaskExtended(false);

        // 4. Reset CORRECTIVE ACTION states (IMPORTANT)
        setCorrActionEditingKey(null);
        setCorrActionCurrentStatus(null);
        setCurrentQAStatus(null);
        setIsCurrentCorrActionExtended(false);
        setIsCorrActionBtnEditing(false);

        setisReopenRequest(false);
        setisAddDisable(false);


        // 5. Reset global editing flag
        setIsEditing(false);

        setisCorrActionTable(false);

        setAssigneeOptions([]);
        assigneeCache.current.clear();
        assigneeIdCache.current.clear();

        setCorrectiveAssigneeOptions([]);
        correctiveassigneeCache.current.clear();
        correctiveAssigneeIdCache.current.clear();

        // 6. Clear hidden/internal fields
        form.setFieldsValue({
            assignedToId: [],
            correctiveActionUserToIds: [],
            hdntaskDetailId: null,
        });
    };

    //#endregion

    //#region Table Columns For Task and Corrective Actions
    const CorrectiveActionColumns = [
        {
            title: 'Findings',
            dataIndex: 'Findings',
            key: 'Findings',
        },
        {
            title: 'Corrective Action',
            dataIndex: 'CorrectiveAction',
            key: 'CorrectiveAction',
        },
        {
            title: 'Assigned To',
            dataIndex: 'CACorrectiveActionAssignedToIds',
            key: 'CACorrectiveActionAssignedToIds',
            render: (value: any, record: any) => {
                // 1. If record already has name (like single select)
                if (record?.corrActionOwnersName) {
                    return record.corrActionOwnersName;
                }

                if (!value) return "-";

                // 2. Normalize to array
                const values = Array.isArray(value) ? value : [value];

                const labels = values.map((item: any) => {
                    const id = item?.value ?? item;

                    const fromIdCache = correctiveAssigneeIdCache.current.get(id);
                    if (fromIdCache) return fromIdCache.label;

                    // 3. First check formOptions
                    const fromOptions = formOptions?.Assignee?.find(
                        (opt: any) => opt.value == id
                    )?.label;

                    if (fromOptions) return fromOptions;

                    // 4. Fallback to cache (same as your single select)
                    return assigneeFromCorrectiveActionSummary.current.get(id);
                });

                // 5. Clean + join
                return labels.filter(Boolean).join(", ") || "-";
            }
        },
        {
            title: 'Deadline',
            dataIndex: 'CorrectiveActionDeadline',
            key: 'CorrectiveActionDeadline',
            render: (value: any) => {
                // console.log('deadline value =>', value)
                return value ? dayjs(value)?.format('DD-MM-YYYY') : null
            },
        },
        {
            title: 'Status',
            dataIndex: 'taskQAStatus',
            key: 'taskQAStatus',
            render: (value: any) => {

                return value ? value : "Pending";
            },
        },
        // {
        //   title: 'Remarks',
        //   dataIndex: 'remarks',
        //   key: 'remarks',
        // },
        {
            title: 'Actions',
            key: 'actions',
            render: (_: any, record: any) => (
                <>
                    {(
                        (
                            Number(requestStatus) === RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa ||
                            Number(requestStatus) === RequestStatusEnum.CorrectiveActionsWipWithOwner
                        ) && isValidCentralQATeam && record.centralQAStatusId != TaskStatusEnum.Closed
                    ) ||
                        (
                            Number(requestStatus) === RequestStatusEnum.CorrectiveActionsWipWithOwner &&
                            isValidCorrectiveActionOwner && record.correctiveActionOwnerStatusId != TaskStatusEnum.Closed
                        ) ?
                        <Button type="link" onClick={() => handleCorrActionEdit(record)}>
                            <EditOutlined />
                        </Button>
                        :
                        <Button type="link" onClick={() => handleCorrActionEdit(record)}>
                            <EyeOutlined />
                        </Button>
                    }
                    {(RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa == requestStatus &&
                        commonContextParams?.roleId == RoleEnum.CentralQaTeam &&
                        record.centralQAStatusId !== TaskStatusEnum.Closed
                    ) ?

                        <Button type="link" onClick={() => handleCorrActionDelete(record)}>
                            <DeleteOutlined />
                        </Button>
                        :
                        <></>
                    }

                    <Button type="link" onClick={() => getCorrActionHistoryGridData(record)}>
                        <HistoryOutlined />
                    </Button>

                </>
            ),
        },
    ];
    //#endregion

    //#region History
    const formatToLocal = (utcDate: string) => {
        return dayjs.utc(utcDate).local().format("DD-MM-YYYY hh:mm A");
    };

    const Historycolumns = [
        {
            title: "Timestamp",
            dataIndex: "timestamp",
            key: "timestamp",
            render: (value: string) => formatToLocal(value),
        },
        {
            title: "Role",
            dataIndex: "role",
        },
        {
            title: "Username",
            dataIndex: "username",
        },
        {
            title: "Status",
            dataIndex: "status",
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            render: (value: string) => value || "-",
        },
        {
            title: "TAT",
            dataIndex: "tat",
        },
    ];

    const getCorrActionHistoryGridData = async (record: any) => {
        try {
            const obj = {
                CorrectiveActionId: record?.correctiveActionId,
            };
            const res = await API.post(getCorrectiveActionHistory, obj);
            console.log("Corr Action history res ==>", res);

            if (res?.data?.data?.length > 0) {
                setHistoryData(res?.data?.data);
            }

            setIsHistoryIconClicked(true);
        } catch (error) {
            console.error("Corr Action History API Error:", error);
        }
    };

    const handleHistoryClose = () => {
        setIsHistoryIconClicked(false);
        setHistoryData([]);
    };

    //#endregion

    //#region Task Details Methods
    const fetchTaskSummaryDetails = async () => {
        const res = await API.post(getTaskSummaryDetails,
            {
                RequestId: location?.state?.RId,
                CreatedBy: commonContextParams?.userId,
                RoleId: commonContextParams?.roleId
            })
        // console.log('Task summary details response', res); 
        if (res?.data?.data?.length > 0) {
            // const formattedData = res?.data?.data?.map((item: any) => ({
            //   ...item,
            //   key: item?.taskDetailId,
            //   assignedToId: item?.assignedToIds
            //     ? item.assignedToIds.split(",").map((id: any) => Number(id))
            //     : [],

            //   Name: item?.name || "-"
            // }));

            const formattedData = res?.data?.data?.map((item: any) => {
                const ids = item?.assignedToIds
                    ? item.assignedToIds.split(",").map((id: any) => Number(id))
                    : [];

                const names = item?.name ? item.name.split(",") : [];

                // 🔥 STORE ID → NAME mapping
                ids.forEach((id: number, index: number) => {
                    const label = names[index]?.trim();

                    if (label) {
                        assigneeIdCache.current.set(id, { value: id, label });
                        assigneeFromTaskSummary.current.set(id, label);
                    }
                });

                return {
                    ...item,
                    key: item?.taskDetailId,
                    assignedToId: ids,
                    name: item?.name || "-"
                };
            });

            setTaskDetailsData(formattedData);
            return formattedData;
        }
    }
    //#endregion

    //#region Corrective Action Details Methods
    const handleCorrActionAdd = async () => {
        try {

            var Fields = ['correctiveactionfinding', 'taskCorrectiveaction', 'correctiveActionUserToIds', 'correctiveActionDeadline'];
            const values = await form.validateFields(Fields);
            console.log("values on add", values);

            // ✅ STEP 1: Extract names (same as TASK)
            let corrActionNames = "";

            if (values.correctiveActionUserToIds) {
                const items = Array.isArray(values.correctiveActionUserToIds)
                    ? values.correctiveActionUserToIds
                    : [values.correctiveActionUserToIds];

                const names = items.map((item: any) => {
                    const id = item?.value ?? item;

                    const found = correctiveAssigneeOptions.find(
                        (opt: any) => opt.value === id
                    );
                    if (found) return found.label;

                    if (item?.label) return item.label;

                    return "";
                });

                corrActionNames = names.filter(Boolean).join(", ");
            }

            const formattedTask = {
                key: CorrActioneditingKey ?? Date.now(),
                CorrectiveActionId: CorrActioneditingKey ? values?.CorrectiveActionId : null,
                CorrectiveAction: values.taskCorrectiveaction,
                Findings: values.correctiveactionfinding,
                CorrectiveActionOwnerStatusId: values.statusId?.value ?? values.statusId,
                CorrectiveActionStatusId: values.statusId?.value ?? values.statusId,
                CorrectiveActionDeadline: values.correctiveActionDeadline
                    ? dayjs(values.correctiveActionDeadline).format("YYYY-MM-DD")
                    : null,
                remarks: values.remarks,
                // ✅ STRING for API
                CorrectiveActionAssignedToIds: Array.isArray(values.correctiveActionUserToIds)
                    ? values.correctiveActionUserToIds.map((x: any) => x?.value ?? x).join(',')
                    : values.correctiveActionUserToIds?.value ?? values.correctiveActionUserToIds,

                // ✅ ARRAY for UI
                CACorrectiveActionAssignedToIds: Array.isArray(values.correctiveActionUserToIds)
                    ? values.correctiveActionUserToIds.map((x: any) => x?.value ?? x)
                    : values.correctiveActionUserToIds?.value ?? values.correctiveActionUserToIds,

                // ✅ IMPORTANT (missing earlier)
                name: corrActionNames,
            };

            setIsCorrActionBtnEditing(false);
            let updatedList = [];
            if (CorrActioneditingKey) {
                updatedList = correctiveActionDetailsData?.map((item: any) =>
                    item.key === CorrActioneditingKey ? formattedTask : item
                );
                setCorrectiveActionDetailsData(updatedList);
                setCorrActionEditingKey(null);
            } else {
                updatedList = [...correctiveActionDetailsData, formattedTask];
                setCorrectiveActionDetailsData(updatedList);
            }

            await handleCorrActionPost(updatedList);

            form.resetFields(Fields);
            form.resetFields([
                "taskTitle",
                "taskDescription",
                "assignedToId",
                "taskDeadline",
                "statusId",
                "remarks",
                "ownerAttachments",
                "InvestigatorStatus",
                "taskClosureRemarks",
            ]);
            setOwnerFiles([]);
            setClosureFiles([]);
            resetActionTab();

        } catch (error) {
            console.log("Validation Failed:", error);
        }
    };

    const handleCorrActionUpdate = async () => {
        await withLoader(async () => {
            try {
                if (isValidCorrectiveActionOwner) {
                    await form.validateFields(["correctiveActionOwnerStatus", "correctiveActionOwnerRemarks"]);
                } else if (
                    (isValidCentralQATeam) &&
                    CorrActionCurrentStatus == TaskStatusEnum.Closed
                ) {
                    await form.validateFields(["QAStatus", "QAClosureRemarks"]);
                } else if (
                    isValidCentralQATeam
                ) {
                    console.log("validating fields for RnD manager/ head");
                    await form.validateFields(["correctiveActionUserToIds", "correctiveActionDeadline"]);
                }

                const values = form.getFieldsValue();
                console.log("values update===>", values, "edit key", editingKey);

                // const selectedTask = taskDetailsData.find(
                //     (x: any) => x.key === values.hdntaskDetailId
                // )

                const formattedTask = {
                    key: CorrActioneditingKey ?? Date.now(),
                    CorrectiveActionId: CorrActioneditingKey ?? null,
                    // TaskDetailId: selectedTask?.taskDetailId ?? null,
                    // CAtaskTitle: selectedTask.taskTitle ?? "",
                    // CAtaskDescription: selectedTask.taskDescription ?? "",
                    CorrectiveAction: values.taskCorrectiveaction ?? "",
                    Findings: values.correctiveactionfinding ?? "",
                    CorrectiveActionAssignedToIds: Array.isArray(values.correctiveActionUserToIds) ? values.correctiveActionUserToIds.map((x: any) => x?.value ?? x).join(',') : values.correctiveActionUserToIds?.value ?? values.correctiveActionUserToIds,
                    CACorrectiveActionAssignedToIds: Array.isArray(values.correctiveActionUserToIds)
                        ? values.correctiveActionUserToIds.map((x: any) => x?.value ?? x)
                        : values.correctiveActionUserToIds?.value ?? values.correctiveActionUserToIds,

                    CorrectiveActionOwnerStatusId: values.correctiveActionOwnerStatus?.value ?? values.correctiveActionOwnerStatus,
                    CorrectiveActionStatusId: values.correctiveActionOwnerStatus?.value ?? values.correctiveActionOwnerStatus,
                    CorrectiveActionDeadline: values.correctiveActionDeadline
                        ? dayjs(values.correctiveActionDeadline).format("YYYY-MM-DD")
                        : null,
                    CorrectiveActionOwnerRemarks: values.correctiveActionOwnerRemarks,
                };


                console.log("formatted task for update =>", formattedTask);
                if (
                    formattedTask?.CorrectiveActionStatusId == TaskStatusEnum.Pending &&
                    commonContextParams?.roleId == RoleEnum.CorrectiveActionOwner
                ) {
                    message.error("Corrective Action cannot be moved back to Pending status.");
                    console.error("Corrective Action cannot be moved back to Pending status.");
                    return;
                }

                const assignTo = Array.isArray(values?.correctiveActionUserToIds)
                    ? values.correctiveActionUserToIds.map((item: any) => item?.value ?? item)
                    : typeof values?.correctiveActionUserToIds === "object" &&
                        values?.correctiveActionUserToIds !== null
                        ? values.correctiveActionUserToIds.value
                        : values?.correctiveActionUserToIds;

                const formData = new FormData();

                formData.append("RequestId", location?.state?.RId);
                //formData.append("TaskDetailId", formattedTask.TaskDetailId ? String(formattedTask.TaskDetailId) : "0");
                formData.append("CorrectiveActionId", formattedTask.CorrectiveActionId ? String(formattedTask.CorrectiveActionId) : "0");

                formData.append("Findings", formattedTask?.Findings);
                formData.append("CorrectiveAction", formattedTask?.CorrectiveAction);
                formData.append("CorrectiveActionAssignedToIds", assignTo);
                formData.append(
                    "CorrectiveActionDeadline",
                    formattedTask?.CorrectiveActionDeadline
                        ? dayjs(formattedTask?.CorrectiveActionDeadline).format("YYYY-MM-DD")
                        : "",
                );

                formData.append("CorrectiveActionOwnerRemarks", formattedTask?.CorrectiveActionOwnerRemarks || "");

                if (values?.correctiveActionOwnerStatus != undefined && values?.correctiveActionOwnerStatus != null) {

                    formData.append("CorrectiveActionOwnerStatusId", values?.correctiveActionOwnerStatus ?? null);
                }

                // OWNER FILES
                CAownerFiles?.forEach((file) => {
                    if (file?.originFileObj) {
                        formData.append("CorrectiveActionOwnerAttachments", file?.originFileObj);
                    }
                });

                formData.append(
                    "CorrectiveActionOwnerAttachmentIds",
                    CAownerFiles
                        ?.filter((f: any) => f?.id)
                        ?.map((f: any) => f?.id)
                        ?.join(","),
                );

                formData.append("CreatedBy", commonContextParams?.userId);
                formData.append("RoleId", commonContextParams?.roleId);

                if (values?.QAStatus != undefined && values?.QAStatus != null) {

                    formData.append("CentralQAStatusId", values?.QAStatus || null);
                }
                formData.append(
                    "CentralQAClosureRemarks",
                    values?.QAClosureRemarks || "",
                );


                const res = await API.post(UpdateCorrectiveActionAsync, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                console.log("updated res by task owner =>", res);

                if (res?.data?.data?.length > 0) {
                    message.success("Corrective Action updated successfully");

                    var CATaskData = await fetchCorrectiveActionSummaryDetails();

                    var isQAUpdateTask = false;

                    if (isValidCorrectiveActionOwner) {
                        const allClosed = CATaskData?.every(
                            (task: any) => task.correctiveActionOwnerStatusId === TaskStatusEnum.Closed,
                        );

                        if (allClosed) {
                            //navigate(-1);
                            redirectToDashboard();
                        }
                    } else if (isValidCentralQATeam) {

                        // const allClosed = CATaskData?.every(
                        //   (task: any) => task.centralQAStatusId === TaskStatusEnum.Closed,
                        // );

                        const allTasksHaveCA = taskDetailsData.every(task =>
                            CATaskData.some(ca => ca.taskDetailId === task.taskDetailId)
                        );

                        const allCAClosed = CATaskData.every(
                            ca => ca.centralQAStatusId === TaskStatusEnum.Closed
                        );

                        isQAUpdateTask = true;

                        ////Commented (now we don't want to check for all tasks having CA as mandatory only one CA for task is sufficient and if that is closed then we can move the request to closure)
                        ///const isAllClosed = allTasksHaveCA && allCAClosed;
                        const isAllClosed = allCAClosed;

                        if (isAllClosed) {
                            isQAUpdateTask = false;
                            setRequestStatus(RequestStatusEnum.AllCorrectiveActionsClosed);

                            setTimeout(() => {
                                const element = document.getElementById("closure-section");
                                if (element) {
                                    element.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start"
                                    });
                                }
                            }, 200);
                        }
                    }

                    if (!isQAUpdateTask) {
                        setShowForm(false);
                    }
                    // setShowForm(false);
                    setEditingKey(null);
                    setCorrActionEditingKey(null);
                    if (commonContextParams?.roleId == RoleEnum.CorrectiveActionOwner) {
                        form.resetFields([
                            "taskTitle",
                            "taskDescription",
                            "assignedToId",
                            "taskDeadline",
                            "statusId",
                            "remarks",
                            "ownerAttachments",
                            "correctiveactionfinding",
                            "taskCorrectiveaction",
                            "correctiveActionUserToIds",
                            "correctiveActionDeadline",
                            "correctiveActionOwnerStatus",
                            "correctiveActionOwnerRemarks",
                            "CorrectiveActionOwnerAttachments",
                        ]);
                    } else if (
                        commonContextParams?.roleId == RoleEnum.CentralQaTeam
                    ) {
                        form.resetFields([
                            "taskTitle",
                            "taskDescription",
                            "assignedToId",
                            "taskDeadline",
                            "statusId",
                            "remarks",
                            "ownerAttachments",
                            "InvestigatorStatus",
                            "taskClosureRemarks",
                            "correctiveactionfinding",
                            "taskCorrectiveaction",
                            "correctiveActionUserToIds",
                            "correctiveActionDeadline",
                            "correctiveActionOwnerStatus",
                            "correctiveActionOwnerRemarks",
                            "CorrectiveActionOwnerAttachments",
                        ]);
                    }
                    resetActionTab();
                    setOwnerFiles([]);
                    setClosureFiles([]);
                    setIsEditing(false);
                } else {

                    const data = res?.data;

                    if (data?.status === ApiStatus.OK || data?.status === ApiStatus.Success) {
                        //SUCCESS CASE
                        message.success(data?.message?.trim() || "Corrective Action updated successfully");
                        // navigate(-1);
                        redirectToDashboard();
                    } else {
                        //ERROR CASE
                        const errorMessage =
                            (data?.errorCode === "DB_VALIDATION" || data?.errorCode === "DBVALIDATION")
                                ? data?.message?.trim() || "Failed"
                                : "Something went wrong!";

                        message.error(errorMessage);
                    }

                }
            } catch (error) {
                console.log("Validation Failed:", error);
            }
        });
    };

    const handleCorrActionEdit = (record: any) => {
        setIsEditing(true);
        if (isValidCentralQATeam) {
            setIsCorrActionBtnEditing(true);
        }

        // setEditingKey(record.taskdetailId ?? record.TaskDetailId);
        setCorrActionEditingKey(record.correctiveActionId ?? record.key);
        setCorrActionCurrentStatus(record?.correctiveActionOwnerStatusId);
        setCurrentQAStatus(record?.centralQAStatusId)
        setIsCurrentCorrActionExtended(record?.isExtended);

        // setTaskCurrentStatus(record?.statusId);
        // setCurrentInvestigatorStatus(record?.investigatorStatusId)

        setisReopenRequest(false);
        if (isReopened &&
            record.taskDetailId > 0 &&
            record?.centralQAStatusId == TaskStatusEnum.Closed
        ) {
            setisReopenRequest(true);
        }


        if (record?.centralQAStatusId == TaskStatusEnum.Closed) {
            setisAddDisable(true);
        }
        setisCorrActionTable(true);
        // setisTaskTable(false);
        setShowForm(true);

        // // // --- Fix: Ensure Assigned To dropdown is set for new (unsaved) tasks ---
        // if (record.assignedToId) {
        //     const ids = Array.isArray(record.assignedToId)
        //         ? record.assignedToId
        //         : [record.assignedToId];

        //     // If names are available (new/unsaved row)
        //     if (record.name) {
        //         const names = Array.isArray(record.name)
        //             ? record.name
        //             : record.name.split(","); // fallback if comma-separated

        //         const options = ids.map((id: any, index: number) => ({
        //             value: id,
        //             label: names[index]?.trim() || `User ${id}`, // safe fallback
        //         }));

        //         setAssigneeOptions(options);

        //         // cache all
        //         ids.forEach((id: any, index: number) => {
        //             assigneeCache.current.set(id.toString(), options[index]);
        //         });

        //     } else {
        //         // Fallback to normal fetch for existing tasks (multiple)
        //         ids.forEach((id: any) => {
        //             fetchCurrentAssignedUser(id);
        //         });
        //     }
        // } else {
        //     setAssigneeOptions([]);
        // }

        // // --- Fix: Ensure Assigned To dropdown is set for new (unsaved) tasks ---
        if (record.CACorrectiveActionAssignedToIds) {
            const ids = Array.isArray(record.CACorrectiveActionAssignedToIds)
                ? record.CACorrectiveActionAssignedToIds
                : [record.CACorrectiveActionAssignedToIds];

            // If names are available (new/unsaved row)
            if (record.corrActionOwnersName) {
                const names = Array.isArray(record.corrActionOwnersName)
                    ? record.corrActionOwnersName
                    : record.corrActionOwnersName.split(","); // fallback if comma-separated

                const options = ids.map((id: any, index: number) => ({
                    value: id,
                    label: names[index]?.trim() || `User ${id}`, // safe fallback
                }));

                setCorrectiveAssigneeOptions(options);

                // cache all
                ids.forEach((id: any, index: number) => {
                    correctiveassigneeCache.current.set(id.toString(), options[index]);
                });

            } else {
                // Fallback to normal fetch for existing tasks (multiple)
                ids.forEach((id: any) => {
                    fetchCurrentCorrAssignedUser(id);
                });
            }
        } else {
            setCorrectiveAssigneeOptions([]);
        }

        ////Scroll to section based on role and task status
        var sectionName = "";
        if (isValidCentralQATeam &&
            record?.correctiveActionOwnerStatusId == TaskStatusEnum.Closed &&
            record?.centralQAStatusId != TaskStatusEnum.Closed) {
            sectionName = "caaction-qa-section";
        } else if (isValidCorrectiveActionOwner && record?.correctiveActionOwnerStatusId != TaskStatusEnum.Closed) {
            sectionName = "caaction-owner-section";
        } else {
            sectionName = "caaction-initiation-section";
        }
        scrollToSection(sectionName);
        console.log('scrolling to section =>', sectionName);

        form.setFieldsValue({
            hdntaskDetailId: record.taskDetailId ?? record.TaskDetailId,
            taskTitle: record.taskTitle ?? record.CAtaskTitle,
            taskDescription: record.taskDescription ?? record.CAtaskDescription,
            assignedToId: record.assignedToId,
            taskDeadline: record.taskDeadline
                ? dayjs(record.taskDeadline)
                : null,
            correctiveActionOwnerStatus: record.correctiveActionOwnerStatusId,
            correctiveActionOwnerRemarks: record.correctiveActionOwnerStatusId == TaskStatusEnum.Closed ? record.correctiveActionOwnerRemarks : "",

            correctiveactionfinding: record.Findings,
            taskCorrectiveaction: record.CorrectiveAction,
            correctiveActionUserToIds: record.CACorrectiveActionAssignedToIds,

            correctiveActionDeadline: record.CorrectiveActionDeadline
                ? dayjs(record.CorrectiveActionDeadline)
                : null,
            QAStatus: record.centralQAStatusId != undefined && record.centralQAStatusId != null ? record.centralQAStatusId : null,
            QAClosureRemarks: record.centralQAClosureRemarks != undefined && record.centralQAClosureRemarks != null ? record.centralQAClosureRemarks : "",

            statusId: record.statusId,
            remarks: record.remarks ?? record.AOTaskRemark,

            InvestigatorStatus: record?.investigatorStatusId,
            taskClosureRemarks: record?.investigatorClosureRemarks,
        })

        if (record?.taskOwnerAttachments) {
            const parsed = JSON.parse(record.taskOwnerAttachments);

            const owner = parsed.map((file: any) => ({
                uid: file.id.toString(),
                name: file.name,
                status: "done",
                url: file.path,
                existing: true,
                id: file.id,
            }));

            setOwnerFiles(owner);

        } else {
            setOwnerFiles([]);
        }

        if (record?.correctiveOwnerAttachments) {
            const parsed = JSON.parse(record.correctiveOwnerAttachments);

            const CAowner = parsed.map((file: any) => ({
                uid: file.id.toString(),
                name: file.name,
                status: "done",
                url: file.path,
                existing: true,
                id: file.id,
            }));

            setCAownerFiles(CAowner);

        } else {
            setCAownerFiles([]);
        }
    }

    const handleCorrActionDelete = (record: any) => {
        const updatedData = correctiveActionDetailsData.filter((item: any) => item.key !== record.key);
        setCorrectiveActionDetailsData(updatedData);
    }

    const fetchCorrectiveActionSummaryDetails = async () => {

        const res = await API.post(GetCorrectiveActionSummaryDetails, {
            RequestId: location?.state?.RId,
            CreatedBy: commonContextParams?.userId,
            RoleId: commonContextParams?.roleId
        });

        if (res?.data?.data?.length > 0) {

            const formattedData = res?.data?.data?.map((item: any) => {
                const ids = item?.assignedToIds
                    ? item.assignedToIds.split(",").map((id: any) => Number(id))
                    : [];

                const names = item?.name ? item.name.split(",") : [];

                // 🔥 STORE ID → NAME mapping
                ids.forEach((id: number, index: number) => {
                    const label = names[index]?.trim();

                    if (label) {
                        assigneeIdCache.current.set(id, { value: id, label });
                        assigneeFromTaskSummary.current.set(id, label);
                    }
                });

                const corrActionids = item?.correctiveActionAssignedToIds
                    ? item.correctiveActionAssignedToIds.split(",").map((id: any) => Number(id))
                    : [];

                const corrActionOwnersName = item?.corrActionOwnersName ? item.corrActionOwnersName.split(",") : [];

                // 🔥 STORE ID → NAME mapping
                corrActionids.forEach((id: number, index: number) => {
                    const label = corrActionOwnersName[index]?.trim();

                    if (label) {
                        correctiveAssigneeIdCache.current.set(id, { value: id, label });
                        assigneeFromCorrectiveActionSummary.current.set(id, label);
                    }
                });

                return {
                    ...item,
                    key: item?.correctiveActionDetailId,
                    assignedToId: ids,
                    name: item?.name || "-",
                    CACorrectiveActionAssignedToIds: corrActionids,
                    corrActionOwnersName: item?.corrActionOwnersName || "-",
                    CorrectiveActionId: item?.correctiveActionDetailId,
                    TaskDetailId: item?.taskDetailId,
                    CAtaskTitle: item?.taskTitle,
                    CAtaskDescription: item?.taskDescription,
                    Findings: item?.findings,
                    CorrectiveAction: item?.correctiveAction,
                    CorrectiveActionDeadline: item?.correctiveActionDeadline,
                    CorrectiveActionOwnerStatusId: item?.correctiveActionOwnerStatusId,
                };
            });

            setCorrectiveActionDetailsData(formattedData);

            return formattedData;
        }

        return [];
    };

    const handleCorrActionPost = async (dataOverride: any) => {
        await withLoader(async () => {

            const req = {
                // 🔴 FIX: use override
                CorrectiveActionSummaryList: dataOverride || correctiveActionDetailsData,

                CreatedBy: commonContextParams?.userId,
                RequestId: location.state ? location.state?.RId : 0,
                RoleId: commonContextParams?.roleId,
            };

            const res = await API.post(InsertCorrectiveActionAsync, req);
            const data = res?.data;

            if (data?.status === ApiStatus.OK || data?.status === ApiStatus.Success) {

                const createdItems = data?.data || [];

                // 🔴 FIX: merge IDs into state
                const updatedList = (dataOverride || correctiveActionDetailsData).map((item: any) => {
                    const match = createdItems.find(
                        (x: any) => x.taskId === item.TaskDetailId
                    );

                    if (match) {
                        return {
                            ...item,
                            CorrectiveActionId: match.correctiveActionId
                        };
                    }

                    return item;
                });

                setCorrectiveActionDetailsData(updatedList);

                message.success(data?.message?.trim() || "Corrective Action submitted successfully");

                // const allTasksHaveCA = taskDetailsData.every(task =>
                //     req.CorrectiveActionSummaryList.some(ca => ca.TaskDetailId === task.taskDetailId)
                // );

                // if (allTasksHaveCA) {
                //     redirectToDashboard();
                // }
                // else {

                // sessionStorage.setItem("redirectToCorrActionDetails", "true");
                // navigate(0);

                await withLoader(async () => {   // 🔥 ADDED

                    fetchCorrectiveActionSummaryDetails();

                });

                if (requestStatus == RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa) {
                    setRequestStatus(RequestStatusEnum.CorrectiveActionsWipWithOwner);
                }

                // }
            } else {
                const errorMessage =
                    (data?.errorCode === "DB_VALIDATION" || data?.errorCode === "DBVALIDATION")
                        ? data?.message?.trim() || "Failed"
                        : "Something went wrong!";

                message.error(errorMessage);
            }
        });
    };

    const handleCorrActionSubmit = async () => {
        await withLoader(async () => {

            if (correctiveActionDetailsData?.length > 0) {

                const values = form.getFieldsValue();
                // const allFields = form.getFieldsValue();
                console.log('all fields=>', correctiveActionDetailsData);
                const req = {
                    CorrectiveActionSummaryList: correctiveActionDetailsData || [],
                    CreatedBy: commonContextParams?.userId,
                    RequestId: location.state ? location.state?.RId : 0,
                    TaskDetailId: values?.taskDetailId || 0,
                    RoleId: commonContextParams?.roleId,
                }
                const res = await API.post(InsertCorrectiveActionAsync, req);
                console.log('result on submit =>', res)
                const data = res?.data;

                if (data?.status === ApiStatus.OK || data?.status === ApiStatus.Success) {
                    //SUCCESS CASE
                    // message.success(data?.message?.trim() || "Corrective Action submitted successfully");
                    //navigate(-1);
                    //redirectToDashboard();

                    const createdItems = data?.data || [];
                    // ✅ Merge returned IDs into existing state
                    const updatedList = correctiveActionDetailsData.map((item: any) => {
                        const match = createdItems.find(
                            (x: any) => x.taskId === item.taskDetailId
                        );

                        if (match) {
                            return {
                                ...item,
                                correctiveActionId: match.correctiveActionId
                            };
                        }

                        return item;
                    });

                    setCorrectiveActionDetailsData(updatedList);

                    message.success(data?.message?.trim() || "Corrective Action submitted successfully");


                } else {
                    //ERROR CASE
                    const errorMessage =
                        (data?.errorCode === "DB_VALIDATION" || data?.errorCode === "DBVALIDATION")
                            ? data?.message?.trim() || "Failed"
                            : "Something went wrong!";

                    message.error(errorMessage);
                }

            } else {
                console.log('inside else ')
                message.error("Assign at least one task!")
            }

        });
    }

    //#endregion

    //#region On Load Call Methods

    const scrollToSection = (sectionName: string) => {
        requestAnimationFrame(() => {
            const element = document.getElementById(sectionName);

            if (element) {
                const yOffset = -80; // adjust if header exists
                const y =
                    element.getBoundingClientRect().top +
                    window.pageYOffset +
                    yOffset;

                window.scrollTo({
                    top: y,
                    behavior: "smooth"
                });
            }
        });
    };

    const redirectToDashboard = () => {
        const roleId = Number(commonContextParams?.roleId);

        if (roleId === Number(RoleEnum.TaskActionOwner)) {
            navigate("/ActionDashboard");
        } else if (roleId === Number(RoleEnum.CorrectiveActionOwner)) {
            navigate("/CorrectiveActionDashboard");
        } else {
            navigate("/ComplaintsDashboard");
        }
    };

    const fetchCurrentAssignedUser = async (assignedToId: any) => {
        try {
            const ids = Array.isArray(assignedToId)
                ? assignedToId
                : [assignedToId];

            let options: any[] = [];

            ids.forEach((id: any) => {
                // 1. Task summary cache
                const cachedName = assigneeFromTaskSummary.current.get(id);
                if (cachedName) {
                    options.push({ label: cachedName, value: id });
                    return;
                }

                // 2. Form options
                if (formOptions?.Assignee?.length > 0) {
                    const foundUser = formOptions.Assignee.find(
                        (opt: any) => opt.value === id
                    );
                    if (foundUser) {
                        options.push(foundUser);
                    }
                }
            });

            if (options.length > 0) {
                // 🔥 ADD THIS (IMPORTANT)
                options.forEach((opt) => {
                    assigneeIdCache.current.set(opt.value, opt); // ✅ store proper cache
                });
                // cache each id
                options.forEach((opt) => {
                    assigneeCache.current.set(opt.value.toString(), [opt]);
                });

                // 🔥 CHANGE: merge instead of overwrite
                setAssigneeOptions((prev: any) => {
                    const merged = [...prev, ...options];

                    return Array.from(
                        new Map(merged.map((item) => [item.value, item])).values()
                    );
                });

                return;
            }

            setAssigneeOptions([]);
        } catch (error) {
            console.error("Error fetching assigned user:", error);
            setAssigneeOptions([]);
        }
    };

    const handleCorrAssigneeSearch = async (searchValue: string) => {
        if (correctiveAssigneeSearchTimeout.current) {
            clearTimeout(correctiveAssigneeSearchTimeout.current);
        }

        if (!searchValue || searchValue.trim().length < 2) {
            setCorrectiveAssigneeOptions([]);
            setCorrectiveAssigneeLoading(false);
            return;
        }

        // Cache check
        if (correctiveassigneeCache.current.has(searchValue)) {
            setCorrectiveAssigneeOptions((prev: any) => {
                const cached = correctiveassigneeCache.current.get(searchValue) || [];
                const merged = [...prev, ...cached];

                return Array.from(
                    new Map(merged.map((item) => [item.value, item])).values()
                );
            });
            setCorrectiveAssigneeLoading(false);
            return;
        }

        setCorrectiveAssigneeLoading(true);

        correctiveAssigneeSearchTimeout.current = setTimeout(async () => {
            try {
                const res = await API.post(getAssignedTo, {
                    SearchTerm: searchValue.trim(),
                });

                if (res?.data?.data?.length > 0) {
                    const options = res.data.data.map((item: any) => ({
                        label: item?.name,
                        value: item?.Id,
                    }));

                    options.forEach((opt: any) => {
                        correctiveAssigneeIdCache.current.set(opt.value, opt);
                    });

                    // Cache by search term
                    correctiveassigneeCache.current.set(searchValue, options);

                    // 🔥 CHANGE: merge instead of overwrite
                    setCorrectiveAssigneeOptions((prev: any) => {
                        const merged = [...prev, ...options];

                        return Array.from(
                            new Map(merged.map((item) => [item.value, item])).values()
                        );
                    });
                } else {
                    setCorrectiveAssigneeOptions([]);
                }
            } catch (error) {
                console.error("Error fetching assignees:", error);
                setCorrectiveAssigneeOptions([]);
            } finally {
                setCorrectiveAssigneeLoading(false);
            }
        }, 300);
    };

    const fetchCurrentCorrAssignedUser = async (assignedToId: any) => {
        try {
            const ids = Array.isArray(assignedToId)
                ? assignedToId
                : [assignedToId];

            let options: any[] = [];

            ids.forEach((id: any) => {
                // 1. Task summary cache
                const cachedName = assigneeFromCorrectiveActionSummary.current.get(id);
                if (cachedName) {
                    options.push({ label: cachedName, value: id });
                    return;
                }

                // 2. Form options
                if (formOptions?.Assignee?.length > 0) {
                    const foundUser = formOptions.Assignee.find(
                        (opt: any) => opt.value === id
                    );
                    if (foundUser) {
                        options.push(foundUser);
                    }
                }
            });

            if (options.length > 0) {
                // 🔥 ADD THIS (IMPORTANT)
                options.forEach((opt) => {
                    correctiveAssigneeIdCache.current.set(opt.value, opt); // ✅ store proper cache
                });
                // cache each id
                options.forEach((opt) => {
                    correctiveassigneeCache.current.set(opt.value.toString(), [opt]);
                });

                // 🔥 CHANGE: merge instead of overwrite
                setCorrectiveAssigneeOptions((prev: any) => {
                    const merged = [...prev, ...options];

                    return Array.from(
                        new Map(merged.map((item) => [item.value, item])).values()
                    );
                });

                return;
            }

            setCorrectiveAssigneeOptions([]);
        } catch (error) {
            console.error("Error fetching assigned user:", error);
            setCorrectiveAssigneeOptions([]);
        }
    };

    useEffect(() => {
        const getAssignees = async () => {
            const res = await API.post(getAssignedTo, {})
            // console.log('assignees response', res); 
            if (res?.data?.data?.length > 0) {

                const assignees = res?.data?.data?.map((item: any) => ({
                    label: item?.name,
                    value: item?.Id,
                }));
                setFormOptions((prev: any) => ({ ...prev, Assignee: assignees }));

            }
        };

        const getCorrActionStatusOptions = async () => {
            const res = await API.post(getCorrActionOwnerStatus, {})
            //  console.log('status options response', res); 
            if (res?.data?.data?.length > 0) {
                const statusOptions = res?.data?.data?.map((item: any) => ({
                    label: item?.name,
                    value: item?.Id,
                }));
                setFormOptions((prev: any) => ({ ...prev, CorrActionStatus: statusOptions }));
            }
        };

        const getCorrActionCentralQAStatusOptions = async () => {
            const res = await API.post(getCorrActionCentralQAStatus, {})
            //  console.log('status options response', res); 
            if (res?.data?.data?.length > 0) {
                const QAStatusOptions = res?.data?.data?.map((item: any) => ({
                    label: item?.name,
                    value: item?.Id,
                }));

                setFormOptions((prev: any) => ({ ...prev, CorrActionCentralQAStatus: QAStatusOptions }));
            }
        }

        getAssignees();

        getCorrActionStatusOptions();
        getCorrActionCentralQAStatusOptions();

    }, [])

    useEffect(() => {
        let isMounted = true; // 🔥 track component state

        return () => {
            isMounted = false;

            // if (assigneeSearchTimeout.current) {
            //     clearTimeout(assigneeSearchTimeout.current);
            // }

            if (correctiveAssigneeSearchTimeout.current) {
                clearTimeout(correctiveAssigneeSearchTimeout.current);
            }
        };
    }, []);

    const fetchRequestDetailsById = async (id: any) => {
        const res = await API.post(getRequestDetailsById, { RequestId: id })
        console.log('Request details by id response', res);
        if (res?.data?.data?.length > 0) {
            setRequestStatus(res?.data?.data[0]?.requestStatusId);
            setInvestigator(res?.data?.data[0]?.investigator);

            //#region Hide/Show Form Logic
            const roleId = Number(commonContextParams.roleId);
            const statusId = res?.data?.data[0]?.requestStatusId;

            const isInvestigatorCase =
                roleId === RoleEnum.Investigator &&
                statusId === RequestStatusEnum.ActionAssignmentPendingWithInvestigator;

            // const isQACase =
            //     roleId === RoleEnum.CentralQaTeam &&
            //     statusId === RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa;

            const isQACase =
                roleId === RoleEnum.CentralQaTeam &&
                (statusId === RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa ||
                    statusId === RequestStatusEnum.CorrectiveActionsWipWithOwner);

            if (location?.state.IsCorrActionDashboard == true ||
                isQACase
            ) {
                setShowForm(true);
            }

            //#endregion

            let closureDate = dayjs(res?.data?.data[0]?.requestClosureDate);
            console.log('closure date=>', closureDate)
            console.log(currentInvestigatorStatus);
            setClosureDate(closureDate.format('YYYY-MM-DD'));


            //#region  Consolidated Closure Details

            if (Number(statusId) == RequestStatusEnum.CustomerRatingPending ||
                Number(statusId) == RequestStatusEnum.AllCorrectiveActionsClosed ||
                Number(statusId) == RequestStatusEnum.CustomerRatingsUnderReview ||
                Number(statusId) == RequestStatusEnum.ComplaintClosed) {
                form.setFieldsValue({
                    consodilatedCostAssociated: res?.data?.data[0]?.costAssociated,
                    ConsodilatedClosureRemark: res?.data?.data[0]?.consolidatedClosureRemarks,
                })

                if (res?.data?.data[0]?.consolidatedClosureQAAttachments) {
                    const parsed = JSON.parse(res?.data?.data[0]?.consolidatedClosureQAAttachments);

                    const closureAtt = parsed.map((file: any) => ({
                        uid: file.id.toString(),
                        name: file.name,
                        status: "done",
                        url: file.path,
                        existing: true,
                        id: file.id,
                    }));

                    setQAConsodilatedClosureFiles(closureAtt);

                } else {
                    setQAConsodilatedClosureFiles([]);
                }
            }
            //#endregion

            return res?.data?.data[0];

        }
    }

    useEffect(() => {
        (async () => {
            if (location?.state?.RId && location?.state?.RId > 0) {
                await withLoader(async () => {   // 🔥 ADDED

                    const [CorrectiveActiondata, res] = await Promise.all([  // 🔥 UPDATED
                        //fetchTaskSummaryDetails(),
                        fetchCorrectiveActionSummaryDetails(),
                        fetchRequestDetailsById(location?.state?.RId)
                    ]);

                    // if (location?.state?.TId && location?.state?.TId > 0) {
                    //     console.log('location?.state?.TaskDetailId =>', location?.state?.TId, ' data=>', data)
                    //     const obj = data?.find((e: any) => e.taskDetailId == location?.state?.TId)
                    //     console.log('objjj=>', obj)

                    //     if (location?.state.IsTaskDashboard == true ||
                    //         location?.state.IsCorrActionDashboard == true) {
                    //         setIsEditing(true);
                    //     } else {
                    //         setIsEditing(false);
                    //     }

                    //     setEditingKey(obj.key);
                    //     setTaskCurrentStatus(obj?.statusId);
                    //     setIsCurrentTaskExtended(obj?.isExtended);
                    //     setCurrentInvestigatorStatus(obj?.investigatorStatusId);
                    //     setisCorrActionTable(false);

                    //     // Fetch the currently assigned user(s) to show in the dropdown
                    //     if (obj?.assignedToId) {
                    //         const ids = Array.isArray(obj.assignedToId)
                    //             ? obj.assignedToId.map((item: any) => item?.value ?? item)
                    //             : [obj.assignedToId?.value ?? obj.assignedToId];

                    //         await fetchCurrentAssignedUser(ids);
                    //     }

                    //     form.setFieldsValue({
                    //         taskTitle: obj.taskTitle,
                    //         taskDescription: obj.taskDescription,
                    //         assignedToId: obj.assignedToId?.map((id: number) => {
                    //             const cached = assigneeIdCache.current.get(id);

                    //             return {
                    //                 value: id,
                    //                 label: cached?.label || "", // always try real name
                    //             };
                    //         }),
                    //         assignedToIds: obj?.assignedToId,
                    //         taskDeadline: obj.taskDeadline
                    //             ? dayjs(obj.taskDeadline)
                    //             : null,
                    //         statusId: obj.statusId,
                    //         remarks: obj.remarks,
                    //         InvestigatorStatus: obj?.investigatorStatusId,
                    //         taskClosureRemarks: obj?.investigatorClosureRemarks
                    //     });

                    //     if (obj?.taskOwnerAttachments) {
                    //         const parsedOwner = JSON.parse(obj?.taskOwnerAttachments);

                    //         const owner = parsedOwner.map((file: any) => ({
                    //             uid: file.id.toString(),
                    //             name: file.name,
                    //             status: "done",
                    //             url: file.path,
                    //             id: file.id,
                    //         }));

                    //         setOwnerFiles(owner);
                    //     }

                    // }

                    if (location?.state?.CId && location?.state?.CId > 0) {
                        console.log('location?.state?.correctiveActionDetailId =>', location?.state?.CId, ' data=>', CorrectiveActiondata)
                        const obj = CorrectiveActiondata?.find((e: any) => e.correctiveActionId == location?.state?.CId)
                        console.log('objjj=>', obj)
                        setCorrActionEditingKey(location?.state?.CId);
                        setCorrActionCurrentStatus(obj?.correctiveActionOwnerStatusId);
                        setIsCurrentCorrActionExtended(obj?.isCorrActionExtended);
                        setCurrentQAStatus(obj?.qaStatusId);
                        setisCorrActionTable(true);

                        if (location?.state.IsCorrActionDashboard == true) {
                            setIsEditing(true);
                        } else {
                            setIsEditing(false);
                        }

                        // Fetch the currently assigned user(s) to show in the dropdown
                        if (obj?.assignedToId) {
                            const ids = Array.isArray(obj.assignedToId)
                                ? obj.assignedToId.map((item: any) => item?.value ?? item)
                                : [obj.assignedToId?.value ?? obj.assignedToId];

                            await fetchCurrentAssignedUser(ids);
                        }

                        if (obj?.correctiveActionUserToIds) {
                            const ids = Array.isArray(obj.correctiveActionUserToIds)
                                ? obj.correctiveActionUserToIds.map((item: any) => item?.value ?? item)
                                : [obj.correctiveActionUserToIds?.value ?? obj.correctiveActionUserToIds];

                            await fetchCurrentCorrAssignedUser(ids);
                        }

                        form.setFieldsValue({
                            hdntaskDetailId: obj.taskDetailId,
                            taskTitle: obj.taskTitle,
                            taskDescription: obj.taskDescription,
                            // assignedToId: obj.assignedToId,
                            assignedToId: obj.assignedToId?.map((id: number) => {
                                const cached = assigneeIdCache.current.get(id);

                                return {
                                    value: id,
                                    label: cached?.label || "", // always try real name
                                };
                            }),
                            assignedToIds: Array.isArray(obj.assignedToId)
                                ? obj.assignedToId.join(',') : obj.assignedToId?.toString(),
                            taskDeadline: obj.taskDeadline
                                ? dayjs(obj.taskDeadline)
                                : null,
                            statusId: obj.statusId,
                            remarks: obj.remarks,
                            InvestigatorStatus: obj?.investigatorStatusId,
                            taskClosureRemarks: obj?.investigatorClosureRemarks,
                            correctiveactionfinding: obj.Findings,
                            taskCorrectiveaction: obj.CorrectiveAction,

                            correctiveActionOwnerStatus: obj.correctiveActionOwnerStatusId,
                            correctiveActionOwnerRemarks: obj.correctiveActionOwnerStatusId == TaskStatusEnum.Closed ? obj.correctiveActionOwnerRemarks : "",
                            QAClosureRemarks: obj.centralQAClosureRemarks != undefined && obj.centralQAClosureRemarks != null ? obj.centralQAClosureRemarks : "",
                            QAStatus: obj.centralQAStatusId != undefined && obj.centralQAStatusId != null ? obj.centralQAStatusId : null,

                            correctiveActionUserToIds: obj.CACorrectiveActionAssignedToIds?.map((id: number) => {
                                const cached = correctiveAssigneeIdCache.current.get(id);

                                return {
                                    value: id,
                                    label: cached?.label || "", // always try real name
                                };
                            }),
                            correctiveActionDeadline: obj.CorrectiveActionDeadline
                                ? dayjs(obj.CorrectiveActionDeadline)
                                : null,
                        });

                        if (obj?.taskOwnerAttachments) {
                            const parsedOwner = JSON.parse(obj?.taskOwnerAttachments);

                            const owner = parsedOwner.map((file: any) => ({
                                uid: file.id.toString(),
                                name: file.name,
                                status: "done",
                                url: file.path,
                                id: file.id,
                            }));

                            setOwnerFiles(owner);
                        }

                        if (obj?.correctiveOwnerAttachments) {
                            const parsedOwner = JSON.parse(obj?.correctiveOwnerAttachments);

                            const CAowner = parsedOwner.map((file: any) => ({
                                uid: file.id.toString(),
                                name: file.name,
                                status: "done",
                                url: file.path,
                                id: file.id,
                            }));

                            setCAownerFiles(CAowner);
                        }


                    }
                }); // 🔥 ADDED
            }
        })();
    }, [location?.state?.RId])

    //#endregion

    //#region QA Consolidated Closure

    const handleQAClosureSubmit = async () => {
        await withLoader(async () => {
            try {
                if (canQAClosureSubmit) {
                    await form.validateFields(["ConsodilatedClosureRemark", "consodilatedCostAssociated"]);
                }

                const values = form.getFieldsValue();
                console.log("values update===>", values, "edit key", editingKey);



                const formData = new FormData();

                formData.append("RequestId", location?.state?.RId);
                formData.append("ConsolidatedClosureRemarks", values?.ConsodilatedClosureRemark || null);
                formData.append("CostAssociated", values?.consodilatedCostAssociated || null);
                formData.append("CreatedBy", commonContextParams?.userId);
                formData.append("RoleId", commonContextParams?.roleId);

                // OWNER FILES
                QAConsodilatedClosureFiles?.forEach((file) => {
                    if (file?.originFileObj) {
                        formData.append("ConsolidatedClosureAttachments", file?.originFileObj);
                    }
                });

                formData.append(
                    "ConsolidatedClosureAttachmentIds",
                    QAConsodilatedClosureFiles
                        ?.filter((f: any) => f?.id)
                        ?.map((f: any) => f?.id)
                        ?.join(","),
                );

                const res = await API.post(QAClosureSubmitAsync, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                console.log("updated res by task owner =>", res);

                if (res?.data?.data?.length > 0) {
                    message.success("Saved successfully.");
                    //navigate(-1);
                    redirectToDashboard();
                    fetchTaskSummaryDetails();
                    setEditingKey(null);
                    if (commonContextParams?.roleId == RoleEnum.TaskActionOwner) {
                        form.resetFields([
                            "taskTitle",
                            "taskDescription",
                            "assignedToId",
                            "taskDeadline",
                            "statusId",
                            "remarks",
                            "ownerAttachments",
                        ]);
                    } else if (
                        commonContextParams?.roleId == RoleEnum.Investigator
                    ) {
                        form.resetFields([
                            "taskTitle",
                            "taskDescription",
                            "assignedToId",
                            "taskDeadline",
                            "statusId",
                            "remarks",
                            "ownerAttachments",
                            "InvestigatorStatus",
                            "taskClosureRemarks",
                        ]);
                    }
                    setOwnerFiles([]);
                    setClosureFiles([]);
                    setIsEditing(false);
                } else {

                    const data = res?.data;

                    if (data?.status === ApiStatus.OK || data?.status === ApiStatus.Success) {
                        //SUCCESS CASE
                        message.success(data?.message?.trim() || "Saved successfully");
                        // navigate(-1);
                        redirectToDashboard();
                    } else {
                        //ERROR CASE
                        const errorMessage =
                            (data?.errorCode === "DB_VALIDATION" || data?.errorCode === "DBVALIDATION")
                                ? data?.message?.trim() || "Failed"
                                : "Something went wrong!";

                        message.error(errorMessage);
                    }

                }
            } catch (error) {
                console.log("Validation Failed:", error);
            }
        });
    };

    //#endregion

    //#region Attchement Helper
    const handleCorrActionOwnerRemove = (file: any) => {
        if (file?.id) {
            setDeletedCorrActionOwnerAttachmentIds((prev) =>
                prev ? `${prev},${file.id}` : `${file.id}`,
            );
        }

        setCAownerFiles((prev) => prev.filter((f) => f.uid !== file.uid));
    };
    const handleConsodilatedClosureRemove = (file: any) => {
        if (file?.id) {
            setDeletedClosureAttachmentIds((prev) =>
                prev ? `${prev},${file.id}` : `${file.id}`,
            );
        }

        setQAConsodilatedClosureFiles((prev) => prev.filter((f) => f.uid !== file.uid));
    };
    const beforeUpload = useCallback(
        (file: File, fileList: UploadFile[]): boolean | typeof Upload.LIST_IGNORE => {
            setAlertMessage("");
            const ext = extractFileExtension(file.name);
            const allowed = acceptedTypes.split(",").includes(ext);
            if (!allowed) {
                setAlertMessage(`Only ${acceptedTypes} files are allowed.`);
                return Upload.LIST_IGNORE;
            }
            if (maxDocCount !== 1 && fileList.length >= maxDocCount) {
                setAlertMessage(`You can only upload a maximum of ${maxDocCount} files.`);
                return Upload.LIST_IGNORE;
            }

            if (maxFileSize && file.size > maxFileSize * 1024 * 1024) {
                setAlertMessage(
                    `File ${file.name} exceeds the maximum size of ${maxFileSize} MB.`
                );
                return Upload.LIST_IGNORE;
            }

            if (totalMaxFilesSize) {
                const totalSize =
                    fileList.reduce((sum: any, f: any) => sum + (f.size || 0), 0) + file.size;

                if (totalSize > totalMaxFilesSize * 1024 * 1024) {
                    setAlertMessage(
                        `Total file size exceeds the maximum of ${totalMaxFilesSize} MB.`
                    );
                    return Upload.LIST_IGNORE;
                }
            }

            return false;
        },
        [acceptedTypes, fileList.length, maxDocCount, maxFileSize, totalMaxFilesSize]
    );
    const extractFileExtension = (fileName: string): string =>
        fileName.substring(fileName.lastIndexOf(".")).toLowerCase();

    const openFile = (file: any) => {
        const docPath = file.path ?? file.url;

        if (!docPath) {
            console.error("Missing docPath for file", file);
            return;
        }

        window.open(docPath, "_blank");
    };
    //#endregion

    const withLoader = async (fn: any) => {
        try {
            setLoading(true);
            await fn();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loader />}

            <Col lg={24}>
                <Form
                    form={form}
                    layout="vertical"
                    validateTrigger="onChange"
                    initialValues={{ active: true }}
                //disabled={disableForm}
                >
                    <Row gutter={[16, 16]} key={"newform"}>

                        {ShowForm || isEditing ? (
                            // {canShowForm ? (
                            <>
                                {(1 == 1) &&
                                    (
                                        (
                                            isReopenRequest
                                        ) ||
                                        requestStatus == RequestStatusEnum.TasksWipWithTaskOwner ||
                                        requestStatus == RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa ||
                                        requestStatus == RequestStatusEnum.CorrectiveActionsWipWithOwner ||
                                        requestStatus == RequestStatusEnum.AllCorrectiveActionsClosed ||
                                        requestStatus == RequestStatusEnum.CustomerRatingPending ||
                                        requestStatus == RequestStatusEnum.CustomerRatingsUnderReview ||
                                        requestStatus == RequestStatusEnum.ComplaintClosed
                                    ) ?
                                    <>

                                        {/* <Divider style={{ fontWeight: "bold", color: "#ee2d24" }}>
                                            Corrective Action Detail
                                        </Divider> */}

                                        <div id="caaction-initiation-section">  </div>

                                        <Form.Item name="hdntaskDetailId" hidden>
                                            <Input />
                                        </Form.Item>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            <Form.Item
                                                name="correctiveactionfinding"
                                                label="Finding (Central QA Team)"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Please enter corrective action finding",
                                                    },
                                                ]}
                                            >
                                                <Input.TextArea
                                                    placeholder="Enter Finding"
                                                    rows={4}
                                                    maxLength={1000}
                                                    disabled={!(
                                                        isValidCentralQATeam &&
                                                        (
                                                            Number(requestStatus) === Number(RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa) ||
                                                            Number(requestStatus) === Number(RequestStatusEnum.CorrectiveActionsWipWithOwner)
                                                        ) &&
                                                        Number(CorrActionCurrentStatus) !== Number(TaskStatusEnum.Closed) &&
                                                        !isEditing
                                                    )}
                                                    // disabled={!((
                                                    //     isValidCentralQATeam &&
                                                    //     requestStatus === RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa
                                                    // ) || (isValidCentralQATeam && !isCorrActionExistsForTask()
                                                    //     && currentInvestigatorStatus === TaskStatusEnum.Closed))}
                                                    showCount
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            <Form.Item
                                                name="taskCorrectiveaction"
                                                label="Corrective Action (Central QA Team)"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Please enter corrective action",
                                                    },
                                                ]}
                                            >
                                                <Input.TextArea
                                                    placeholder="Enter Corrective Action"
                                                    rows={4}
                                                    maxLength={1000}
                                                    disabled={!(
                                                        isValidCentralQATeam &&
                                                        (
                                                            Number(requestStatus) === Number(RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa) ||
                                                            Number(requestStatus) === Number(RequestStatusEnum.CorrectiveActionsWipWithOwner)
                                                        ) &&
                                                        Number(CorrActionCurrentStatus) !== Number(TaskStatusEnum.Closed) &&
                                                        !isEditing
                                                    )}
                                                    // disabled={!((
                                                    //     isValidCentralQATeam &&
                                                    //     requestStatus === RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa
                                                    // ) || (isValidCentralQATeam && !isCorrActionExistsForTask()
                                                    //     && currentInvestigatorStatus === TaskStatusEnum.Closed))}
                                                    showCount
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            <Form.Item
                                                name="correctiveActionUserToIds"
                                                label="Assigned To"
                                                rules={[
                                                    { required: true, message: "Please select an assignee" },
                                                ]}
                                            >
                                                <Select
                                                    placeholder="Type at least 2 characters to search"
                                                    mode={'multiple'}
                                                    labelInValue // 🔥 IMPORTANT: required for multi-select objects
                                                    options={correctiveAssigneeOptions || []}
                                                    allowClear
                                                    showSearch
                                                    filterOption={false}
                                                    onSearch={handleCorrAssigneeSearch}
                                                    notFoundContent={
                                                        correctiveassigneeLoading ? (
                                                            <div style={{ textAlign: "center", padding: "10px" }}>
                                                                <Spin size="small" />
                                                            </div>
                                                        ) : correctiveAssigneeOptions.length === 0 ? ( // 🔥 FIXED CONDITION
                                                            "Type at least 2 characters to search"
                                                        ) : (
                                                            "No users found"
                                                        )
                                                    }
                                                    optionFilterProp="label"
                                                    disabled={!(
                                                        isValidCentralQATeam &&
                                                        (
                                                            Number(requestStatus) === Number(RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa) ||
                                                            Number(requestStatus) === Number(RequestStatusEnum.CorrectiveActionsWipWithOwner)
                                                        ) &&
                                                        Number(CorrActionCurrentStatus) !== Number(TaskStatusEnum.Closed)
                                                    )}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            <Form.Item
                                                name="correctiveActionDeadline"
                                                label="Action Deadline"
                                                rules={[{ required: true, message: "Action deadline is required!" }]}
                                            >
                                                <FormDatePicker
                                                    name="correctiveActionDeadline"
                                                    label=""
                                                    placeholder="Select Action Deadline"
                                                    format="DD-MM-YYYY"
                                                    disabled={!(
                                                        isValidCentralQATeam &&
                                                        (
                                                            requestStatus === RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa ||
                                                            requestStatus === RequestStatusEnum.CorrectiveActionsWipWithOwner
                                                        ) &&
                                                        CorrActionCurrentStatus != TaskStatusEnum.Closed
                                                    )}

                                                    disabledDate={(current: any) => {
                                                        return (
                                                            current &&
                                                            current.isBefore(dayjs().startOf("day"))
                                                        );
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </>
                                    :
                                    <></>
                                }

                                {(isCorrActionTable) &&
                                    //(isValidCorrectiveActionOwner) &&
                                    (requestStatus == RequestStatusEnum.TasksWipWithTaskOwner ||
                                        requestStatus == RequestStatusEnum.CorrectiveActionsWipWithOwner ||
                                        requestStatus == RequestStatusEnum.AllCorrectiveActionsClosed ||
                                        requestStatus == RequestStatusEnum.CustomerRatingPending ||
                                        requestStatus == RequestStatusEnum.CustomerRatingsUnderReview ||
                                        requestStatus == RequestStatusEnum.ComplaintClosed) ?
                                    <>

                                        <div id="caaction-owner-section">  </div>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            <Form.Item
                                                name="correctiveActionOwnerStatus"
                                                label="Status"
                                                rules={[
                                                    { required: true, message: "Please select a status" },
                                                ]}
                                            >
                                                <Select
                                                    placeholder="Select Status"
                                                    options={formOptions?.CorrActionStatus || []}
                                                    //options={formOptions?.Status || []}
                                                    allowClear
                                                    disabled={!(isValidCorrectiveActionOwner &&
                                                        CorrActionCurrentStatus !== TaskStatusEnum.Closed)}
                                                    // mode="multiple"
                                                    maxTagCount="responsive"
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            <Form.Item
                                                name="correctiveActionOwnerRemarks"
                                                label="Remarks"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Please enter remarks",
                                                    },
                                                ]}
                                            >
                                                <Input.TextArea
                                                    placeholder="Enter Remarks"
                                                    disabled={!(isValidCorrectiveActionOwner &&
                                                        CorrActionCurrentStatus !== TaskStatusEnum.Closed)}
                                                    rows={4}
                                                    maxLength={1000}
                                                    showCount

                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            {alertMessage && <Alert message={alertMessage} type="warning" showIcon />}
                                            <Form.Item label="Attachments" name={"CorrectiveActionOwnerAttachments"}>
                                                <Upload
                                                    multiple
                                                    //  fileList={attachment1 || []}
                                                    //  onChange={({ fileList }) => setAttachment(fileList)}
                                                    // beforeUpload={(file) => {
                                                    //   const isAllowedSize = file.size / 1024 / 1024 < 30;
                                                    //   if (!isAllowedSize) {
                                                    //     message.error(`${file.name} is larger than 30MB.`);
                                                    //     return Upload.LIST_IGNORE;
                                                    //   }
                                                    //   return false;
                                                    // }}
                                                    maxCount={maxDocCount}
                                                    fileList={CAownerFiles}
                                                    beforeUpload={beforeUpload}
                                                    onChange={({ fileList }) => {
                                                        setCAownerFiles(fileList.slice(0, 5));
                                                    }}
                                                    accept={acceptedTypes}
                                                    onRemove={handleCorrActionOwnerRemove}
                                                    onPreview={openFile}
                                                    disabled={!(isValidCorrectiveActionOwner &&
                                                        CorrActionCurrentStatus !== TaskStatusEnum.Closed)}
                                                >
                                                    <Button icon={<UploadOutlined />}> Upload (Max : {maxDocCount}) </Button>
                                                </Upload>
                                                <label style={{
                                                    marginTop: 4,
                                                    wordBreak: "break-word",
                                                    whiteSpace: "normal"
                                                }}>
                                                    {'(' + acceptedTypes + ')'}
                                                </label>
                                            </Form.Item>
                                        </Col>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            {/* content goes here */}
                                        </Col>
                                    </>
                                    :
                                    <></>
                                }

                                {(CorrActionCurrentStatus == TaskStatusEnum.Closed //&& isValidCentralQATeam
                                ) ?
                                    <>

                                        <div id="caaction-qa-section">  </div>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            <Form.Item
                                                name="QAStatus"
                                                label="Central QA status"
                                                //label="QA Status"
                                                rules={[
                                                    { required: true, message: "Please select a status" },
                                                ]}
                                            >
                                                <Select
                                                    placeholder="Select Status"
                                                    options={formOptions?.CorrActionCentralQAStatus || []}
                                                    allowClear
                                                    disabled={!isValidCentralQATeam || currentQAStatus === TaskStatusEnum.Closed}
                                                    // mode="multiple"
                                                    maxTagCount="responsive"
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            <Form.Item
                                                name="QAClosureRemarks"
                                                label="Closure Remarks"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Please enter remarks",
                                                    },
                                                ]}
                                            >
                                                <Input.TextArea
                                                    placeholder="Enter Remarks"
                                                    disabled={!isValidCentralQATeam || currentQAStatus === TaskStatusEnum.Closed}
                                                    rows={4}
                                                    maxLength={1000}
                                                    showCount

                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            {/* content goes here */}
                                        </Col>

                                        <Col lg={6} xs={24} sm={24} md={12}>
                                            {/* content goes here */}
                                        </Col>

                                    </>
                                    :
                                    <></>
                                }

                                <Col lg={24} xs={24} sm={24} md={12}>
                                    <div className="text-end">

                                        {_showUpdateButton && (
                                            <Button
                                                className="btn-submit"
                                                onClick={() => handleCorrActionUpdate()}
                                                disabled={_disableUpdate}
                                            >
                                                Update
                                            </Button>
                                        )}

                                        {!_showUpdateButton && _showCorrActionAdd && (
                                            <Button
                                                className="btn-submit"
                                                onClick={handleCorrActionAdd}
                                                disabled={CorrActionCurrentStatus === TaskStatusEnum.Closed}
                                            >
                                                Add
                                            </Button>
                                        )}


                                        {_showReset && (
                                            <Button
                                                className="btn-reset"
                                                onClick={resetActionTab}
                                                style={{ marginLeft: 8 }}
                                            >
                                                Reset
                                            </Button>
                                        )}

                                    </div>
                                </Col>

                            </>
                        ) : (
                            <></>
                        )}

                        <Col lg={24} xs={24} sm={24} md={24}>
                            {
                                correctiveActionDetailsData && correctiveActionDetailsData?.length > 0 ?
                                    <>

                                        <div style={{ marginBottom: "16px" }}>
                                            <h6
                                                style={{
                                                    marginBottom: "4px",
                                                    fontWeight: 600,
                                                    borderBottom: "2px solid #d9d9d9",
                                                    paddingBottom: "6px",
                                                    display: "inline-block"
                                                }}
                                            >
                                                Corrective Action Summary
                                            </h6>

                                            {/* <div style={{ fontSize: "12px", color: "#888", fontWeight: "bold" }}>
                                                *Please click on edit icon to add corrective actions.
                                            </div> */}

                                            {(isValidCentralQATeam || isValidCorrectiveActionOwner) && (
                                                <div style={{ fontSize: "12px", color: "#888", fontWeight: "bold" }}>
                                                    *Please click on edit icon to add corrective actions.
                                                </div>
                                            )}

                                        </div>

                                        <Table
                                            columns={CorrectiveActionColumns}
                                            dataSource={correctiveActionDetailsData}
                                            pagination={false}
                                        />
                                    </>
                                    :
                                    <></>
                            }
                        </Col>

                        {requestStatus == RequestStatusEnum.AllCorrectiveActionsClosed ||
                            requestStatus == RequestStatusEnum.CustomerRatingPending ||
                            requestStatus == RequestStatusEnum.CustomerRatingsUnderReview ||
                            requestStatus == RequestStatusEnum.ComplaintClosed
                            ?
                            <>
                                <Col lg={24} xs={24} sm={24} md={12}>
                                    <div id="closure-section">
                                        <h6 style={{
                                            marginBottom: "4px",
                                            fontWeight: 600,
                                            borderBottom: "2px solid #d9d9d9",
                                            paddingBottom: "6px",
                                            display: "inline-block"
                                        }}>Consolidated Closure Details</h6>
                                    </div>
                                </Col>

                                <Col lg={6} xs={24} sm={24} md={12}>
                                    <Form.Item
                                        name="ConsodilatedClosureRemark"
                                        label="Closure Remarks"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please enter closure remarks",
                                            },
                                        ]}
                                    >
                                        <Input.TextArea
                                            placeholder="Enter Closure Remarks"
                                            disabled={!(canQAClosureSubmit)}
                                            rows={4}
                                            maxLength={1000}
                                            showCount

                                        />
                                    </Form.Item>
                                </Col>

                                <Col lg={6} xs={24} sm={24} md={12}>
                                    <Form.Item
                                        name="consodilatedCostAssociated"
                                        label="Cost Associated (USD)"
                                        rules={[
                                            // {
                                            //   required: true,
                                            //   message: "Please enter the cost associated",
                                            // },
                                            {
                                                pattern: /^\d{0,4}(\.\d{0,2})?$/,
                                                message: "Please enter a number with up to 4 digits and 2 decimal places",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Enter Cost Associated"
                                            disabled={!(canQAClosureSubmit)}
                                            maxLength={100}
                                        //showCount
                                        />
                                    </Form.Item>
                                </Col>

                                <Col lg={6} xs={24} sm={24} md={12}>
                                    {alertMessage && <Alert message={alertMessage} type="warning" showIcon />}
                                    <Form.Item label="Supporting Documents" name={"consodilatedAttachment"}>
                                        <Upload
                                            multiple
                                            //  fileList={attachment1 || []}
                                            //  onChange={({ fileList }) => setAttachment(fileList)}
                                            maxCount={maxDocCount}
                                            fileList={QAConsodilatedClosureFiles}
                                            beforeUpload={beforeUpload}
                                            onChange={({ fileList }) => {
                                                setQAConsodilatedClosureFiles(fileList.slice(0, 5));
                                            }}
                                            accept={acceptedTypes}
                                            onRemove={handleConsodilatedClosureRemove}
                                            onPreview={openFile}
                                            disabled={!(canQAClosureSubmit)}
                                        >
                                            <Button icon={<UploadOutlined />}>Upload (Max : {maxDocCount})</Button>
                                        </Upload>
                                        <label>({acceptedTypes})</label>
                                    </Form.Item>
                                </Col>
                            </>
                            :
                            <></>
                        }

                    </Row>
                    {/* {
            requestStatus == RequestStatusEnum.TasksWipWithTaskOwner ? */}
                    <div className='row'>
                        <div className='d-flex justify-content-end gap-2'>
                            <Button
                                className=""
                                onClick={goToPrevTab}
                            >
                                {"<"}
                            </Button>
                            <Button
                                className=""
                                onClick={goToNextTab}
                            >
                                {">"}
                            </Button>

                            {(canQAClosureSubmit) && (
                                <Button
                                    className="btn-submit"
                                    onClick={() =>
                                        canQASubmit
                                            ? handleCorrActionSubmit()
                                            : canQAClosureSubmit
                                                ? handleQAClosureSubmit()
                                                : null
                                    }
                                    disabled={!(canQASubmit || canQAClosureSubmit)}
                                >
                                    Submit
                                </Button>
                            )}

                            {/* <Button className='btn-reset' onClick={() => { navigate(-1) }}> */}
                            <Button className='btn-reset' onClick={() => { redirectToDashboard(); }}>
                                Back
                            </Button>

                        </div>
                    </div>
                    {/* :
              <></>
          } */}


                    <Modal
                        title="Action History"
                        open={isHistoryIconClicked}
                        onOk={handleHistoryClose}
                        onCancel={handleHistoryClose}
                        footer={null}
                        width={800}
                        destroyOnClose
                    >
                        <Table
                            columns={Historycolumns}
                            dataSource={historyData || []}
                            pagination={false}
                            rowKey="id"
                        />
                    </Modal>

                </Form>
            </Col>
        </>
    )
}

export default CorrActionDetailsTab
